// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3-wKu","row":"ProcedureTreatmentSummary_row__3_zrk"};